var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90277 5.90066H18.0977C18.6586 5.90066 19.0963 6.33357 19.0963 6.89153V14.9049C19.0963 15.4629 18.6586 15.8967 18.0977 15.8967H6.97287C6.84066 15.8967 6.71441 15.954 6.62874 16.0547L4.90545 18.0696V6.8913C4.90521 6.33357 5.34289 5.90066 5.90277 5.90066ZM5.90277 5.00024C4.8582 5.00024 4.00002 5.85126 4.00002 6.89177V19.2932C4.00002 19.7122 4.52385 19.9039 4.7971 19.585L7.18073 16.7967H18.0975C19.1435 16.7967 20 15.9461 20 14.9051V6.89153C20 5.85126 19.1435 5 18.0975 5H5.90277V5.00024Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92181 9.27018C6.66861 9.26684 6.46289 9.46874 6.46289 9.71956C6.46289 9.97133 6.66885 10.1735 6.92181 10.1699H17.0802C17.3319 10.1737 17.5391 9.97133 17.5391 9.71956C17.5391 9.46874 17.3319 9.26708 17.0802 9.27018H6.92181Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92181 12.1618C6.66861 12.1575 6.46289 12.3599 6.46289 12.6117C6.46289 12.8625 6.66885 13.0656 6.92181 13.062H11.4693C11.721 13.0658 11.928 12.8625 11.928 12.6117C11.928 12.3599 11.721 12.1578 11.4693 12.1618H6.92181Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendSms);
export default __webpack_public_path__ + "static/media/resend-sms.ac070e7fbc8e13c6f409b036d2466016.svg";
export { ForwardRef as ReactComponent };